import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageModalComponent } from 'src/app/shared/components/message-modal/message-modal.component';

@Injectable({
  providedIn: 'root'
})

export class MessageService {

  constructor(
    public dialogService: DialogService,
    public dialogRef: DynamicDialogRef
  ) { }

  showPopup(content: any, tip: string, contentType?: string, css?: string, errorInfo?: any[], width?: string): any {


    const dialogRef = this.dialogService.open(MessageModalComponent, {
      data: {
        tip: tip,
        Content: content,
        ContentType: contentType ? contentType : '',
        ErrorInfo: errorInfo
      },
      showHeader: false

    });



    // const dialogRef = this.dialog.open(
    //   MessageModalComponent,
    //   {
    //     panelClass: css ? css : '',
    //     width: width ? width : '',
    //     data: {
    //       Content: content,
    //       ContentType: contentType ? contentType : ''
    //     }
    //   });
    // dialogRef.componentInstance.tip = tip;
    // return dialogRef;
  }
  hideModal(): any {
    this.dialogRef.close();

  }
}
